import React, { useEffect, useContext, useState, useRef } from "react";
import { TokenVerificationLoggedin, BlockAdmin } from "../../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../config/config.json";
import { Table, Tooltip, Select, Col, Row, Pagination, Input, Modal, Checkbox } from 'antd';
import { Link } from 'react-router-dom'
import FullLoader from "../../assets/images/full-page-loader.gif"
import prevIcon from '../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../assets/images/icons/chevron-right.svg';
import noData from '../../assets/images/data-graph/no-data.svg';
import TableLoader from "../TableLoader";
import errorData from '../../assets/images/data-graph/error-data.svg';
import mediaKitIcon from '../../assets/images/icons/download_gray_icon.svg';
import { saveAs } from "file-saver";
import { notifyfailure, notifysuccess, notifycatch } from "../../utils/toast"
import uploadCloudIcon from '../../assets/images/icons/upload_cloud_icon.svg';
import uploadIcon from '../../assets/images/icons/upload-cloud.svg';
import uploadFileIcon from '../../assets/images/icons/upload_file_icon.svg';
import deleteIcon from '../../assets/images/icons/trash.svg';
import csvIcon from '../../assets/images/icons/csv.svg';
import txtIcon from '../../assets/images/icons/txt.svg';
import loaderIcon from "../../assets/images/login-and-signup/loader.gif";
const { Option } = Select;

const PublisherDomainListing = () => {

    const loadingContext = useContext(LoadingContext);
    const [apiCall, setApicall] = useState(false)
    const [pageView, setPageView] = useState("table")

    // const [fileViewId, setFileViewId] = useState("")
    // const [fileViewName, setFileViewName] = useState("")
    // const [fileViewExt, setFileViewExt] = useState("")


    const columnsAll = [
        {
            title: 'Action',
            dataIndex: 'action',
            width: 70,
            render: (text, record) => {
                return (

                    <div className='btn_group'

                    >
                        {record?.downloadLoading ?

                            <button className="new_integrate_btn_d2 btn btn_primary loader loader_btn_with_icon">
                                <span> Download</span>
                                <img src={FullLoader} alt="USP" className="" />
                            </button>
                            :
                            <Tooltip title="Download">
                                <button className='download_icon download_icon_d2'
                                    onClick={() => {
                                        handleDownload(record._id, record.fileUrl, record.fileName)
                                    }}
                                >
                                    <img src={mediaKitIcon} alt='USP' /></button>
                            </Tooltip>
                        }
                    </div>
                )
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            fixed: 'left',
            width: 150,
            render: (text) =>
                <div className='w_100 enable_disabled_d2 position-relative'>
                    <button className={`badge_content--${text?.toLowerCase()} btn`}> {text}</button>
                    {/* <button className='badge_content--declined btn'> {text}</button>
                <button className='badge_content--pending btn'> {text}</button> */}
                </div>,
        },
        {
            title: 'File Name',
            dataIndex: 'fileName',
            key: 'fileName',
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text) =>
                <div className='anchor_text_link_d2' style={{ cursor: "default" }}>{text}</div>,
        },
        {
            title: 'Publisher ID',
            dataIndex: 'publisherId',
            key: 'publisherId',
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text) => <div className='text_dark'>{text}</div>,
        },
        {
            title: 'Date Added',
            dataIndex: 'createdAt',
            key: 'createdAt',
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text) => <div className='text_dark'>{text}</div>,
        },
        {
            title: 'Uploaded by',
            dataIndex: 'uploadedBy',
            key: 'uploadedBy',
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (text) => <div className='text_dark'>{text}</div>,
        },
    ];



    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)

    const [page, setPage] = useState({
        current: 1,
        pageSize: 50,
        total: 10,
    });

    const [sort, setSort] = useState({
        name: "",
        type: ""
    });

    const [search, setSearch] = useState("")

    const getData = () => {
        setLoading(true)
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + `adsTxt/pubDomainListing?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}`,
                    // {
                    // filter: filterApplyApiCall
                    // }, 
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        },
                    })
                .then((response) => {
                    setData(response.data.data)
                    if (response.data.data?.data?.length > 0) {
                        let tempPage = { ...page }
                        tempPage.total = response.data?.data?.metaData?.totalRecords

                        setPage(tempPage)
                    }

                    setLoading(false)
                    setInitialLoad(false)
                })
                .catch((error) => {
                    setData([])
                    setLoading(false)
                    setInitialLoad(false)
                });
        }

    }

    useEffect(() => {
        TokenVerificationLoggedin();
        BlockAdmin()
        getData()
        loadingContext.done()
    }, [loadingContext]);



    useEffect(() => {
        if (!initialLoad) {
            getData()
        }
    }, [apiCall])

    useEffect(() => {
        if (!initialLoad) {
            const delayDebounceFn = setTimeout(() => {
                setApicall(!apiCall)
            }, 400); // 500ms delay
            // Cleanup function to clear the timeout if query changes
            return () => clearTimeout(delayDebounceFn);
        }
    }, [search]);



    const handleTableChange = (pagination, filters, sorter) => {
        setSort({ name: sorter.field, type: sorter.order });
        setApicall(!apiCall)
    };

    const handlePageChange = (data) => {

        let tempPage = page
        tempPage.current = data
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const handlePageSizeChange = (e) => {
        let tempPage = page
        tempPage.pageSize = e

        if (tempPage.current > 1) {
            if (e * tempPage.current > tempPage.total) {
                tempPage.current = 1
            }
        }
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };


    // const handlePageViewEdit = (data, reload) => {
    //     if (reload === "yes") {
    //         setApicall(!apiCall)
    //     }
    //     setFileViewId("")
    //     setFileViewName("")
    //     setFileViewExt("")
    //     setPageView(data)

    // }

    const handleDownload = async (id, url, name) => {

        setData(prevData =>
            prevData.map(obj => {
                if (obj["_id"] === id) {
                    return { ...obj, downloadLoading: true };
                }
                return obj;
            })
        );

        try {
            const response = await fetch(url)
            if (!response.ok) {
                throw new Error(`Failed to fetch `);
            }
            const blob = await response.blob();
            saveAs(blob, name);
            notifysuccess("File downloaded successfully")
            setData(prevData =>
                prevData.map(obj => {
                    if (obj["_id"] === id) {
                        return { ...obj, downloadLoading: false };
                    }
                    return obj;
                })
            );

        } catch (error) {
            notifyfailure("Error while downloading the file")
            setData(prevData =>
                prevData.map(obj => {
                    if (obj["_id"] === id) {
                        return { ...obj, downloadLoading: false };
                    }
                    return obj;
                })
            );
        }

    };


    const locale = {
        emptyText:
            <>{search.trim().length > 0 && loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>
                        <div className='float_text_div'>
                        </div>
                    </div>
                </div>
                :
                search.trim().length > 0 && !loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={errorData} className='' alt="" />
                            <div className='float_text_div'>

                            </div>
                        </div>
                    </div>
                    :
                    loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>
                                <div className='float_text_div'>
                                </div>
                            </div>
                        </div>
                        :
                        <div className='no_data_screen' >
                            <div className='text-center'>
                                <img src={noData} className='' alt="" />
                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
            }
            </>

    };





    // Modal related code .............................................................................................................................
    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => {
        setIsModalVisible(true);
    };

    const closeModal = () => {
        setIsModalVisible(false);
        resetModalData()
    };


    useEffect(() => {
        axios
            .get(configData.SERVER_URL + "zone/pubMinifiedList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setPublisherOptions(response.data.data);
            })
            .catch((error) => { });
    }, []);


    function resetModalData() {
        setPublisher("")
        setPublisherIsRequiredError(false)
        setFile({
            data: "",
            filename: "",
            type: "",
            size: ""
        })
        setFileIsRequiredError(false)
        setButtonProcessing(false)

        document.getElementById('filepublisherDomain01').value = ''
    }


    const [buttonProcessing, setButtonProcessing] = useState(false)
    const [publisher, setPublisher] = useState("")
    const [publisherOptions, setPublisherOptions] = useState([])
    const [publisherIsRequiredError, setPublisherIsRequiredError] = useState(false)

    function onChangePublisher(event) {
        setPublisher(event)
        setPublisherIsRequiredError(false)
    }


    const [file, setFile] = useState({
        data: "",
        filename: "",
        type: "",
        size: ""
    });
    const [fileIsRequiredError, setFileIsRequiredError] = useState(false);

    function onChangeFile(e) {
        if (e.target.files[0]) {

            setFileIsRequiredError(false)

            if (
                e.target.files[0].size / (1024 * 1024) <= 100 &&
                (e.target.files[0].type === "text/plain" || e.target.files[0].type === "text/csv")
            ) {

                setFile({
                    data: e.target.files[0],
                    filename: e.target.files[0].name,
                    type: e.target.files[0].type,
                    size: e.target.files[0].size / (1024 * 1024)
                })
            }
            else {
                if (e.target.files[0].size / (1024 * 1024) > 100) {
                    notifyfailure("File should be less than 100 mb")
                }

                else if (!(e.target.files[0].type === "text/plain" || e.target.files[0].type === "text/csv")) {
                    notifyfailure("File should be in either txt or csv format")
                }
            }

        }
    }


    const handleSubmitModal = async (e) => {
        e.preventDefault();

        if (
            publisher !== "" &&
            file.filename !== ""
        ) {
            if (
                publisherIsRequiredError === false &&
                fileIsRequiredError === false
            ) {


                let formData = new FormData();


                formData.append("publisher", publisher);
                formData.append('file', file.data);

                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {

                    setButtonProcessing(true);
                    let token = Cookies.get("token_xapads_ssp");

                    axios
                        .post(configData.SERVER_URL + `adsTxt/pubDomainUpload`, formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                "x-access-token": token,
                            }
                        }
                        )
                        .then((response) => {
                            notifysuccess(response.data.message)
                            setApicall(!apiCall)
                            setIsModalVisible(false)
                            resetModalData()

                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                }
                            } else {
                                notifycatch();
                            }
                            setButtonProcessing(false)
                        });


                }
            }
        } else {
            if (publisher.trim() === "") {
                setPublisherIsRequiredError(true);
            }
            if (file.filename === "") {
                setFileIsRequiredError(true);
            }
        }
    };






    return (
        <>


            <div className="container_box--wrapper pt_header"
                style={{ opacity: pageView === "table" ? 1 : 0, display: pageView === "table" ? "block" : "none" }}
            >
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600">Publisher Domains</h1>

                    <div className="btn_group">
                        {!initialLoad &&
                            <>
                                <button className='btn btn_primary w_fit_content md' onClick={showModal}>
                                    <span><img src={uploadCloudIcon} alt='Add' /> Upload CSV</span>
                                </button>


                            </>}
                    </div>

                </div>
                <div className="d_flex justify_content_between  mb_10">
                    <div className="form_content_block--group">
                        {!initialLoad &&
                            <Input
                                type='text'
                                className='form_control basic md search_input w_table_search'
                                placeholder="Search"
                                value={search}
                                onChange={(e) => {

                                    if (e.target.value.trim().length === 0) {
                                        setLoading(true)
                                    }

                                    setSearch(e.target.value)
                                }}
                            />
                        }
                    </div>
                    <div className="custom_filter_design_d2">
                    </div>

                </div>
                <div className="table_content--box table_empty_screen_d2">
                    {loading && !initialLoad &&
                        <div className="table_new_loader_d2">
                            <img src={FullLoader} className="img-fluid" alt="" />
                        </div>
                    }

                    {initialLoad ?
                        <TableLoader />

                        :
                        <Table
                            columns={columnsAll}
                            pageSize={100}
                            dataSource={data}
                            onChange={handleTableChange}
                            pagination={false}
                            rowKey={(record) => record.id}
                            locale={locale}
                            scroll={{ x: 1500, y: 'calc(100vh - 27rem' }} />


                    }

                    {data.length > 0 &&
                        <Row className="custom_pagination--container">
                            <Col span={6}>
                                <div className="form_content_block--group mb_0">
                                    <Select
                                        className='form_select basic sm no_search'
                                        value={page.pageSize}
                                        onChange={handlePageSizeChange}
                                        style={{ width: 80 }}
                                        showSearch={false}
                                        options={[
                                            { value: 10, label: 10 },
                                            { value: 20, label: 20 },
                                            { value: 50, label: 50 },
                                            { value: 100, label: 100 },
                                        ]} />
                                    <label className='custom_pagination--label'>
                                        items per page
                                    </label>
                                </div>
                            </Col>
                            <Col span={6}>
                                <span className="custom_pagination--total-text">
                                    {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                                </span>
                            </Col>
                            <Col span={6}>
                                <Pagination
                                    current={page.current}  // Pass individual props instead of spreading them
                                    pageSize={page.pageSize}
                                    total={page.total}
                                    onChange={handlePageChange}
                                    showSizeChanger={false}
                                    itemRender={itemRender}
                                    className="custom_pagination" />
                            </Col>
                        </Row>
                    }
                </div>

                <Modal className='custom_modal custom_modal_form_d2'
                    title={
                        <div className='custom_modal--header'>
                            <h3 className='heading'>
                                <img src={uploadFileIcon} alt='USP' /> Upload CSV
                            </h3>
                        </div>
                    }
                    visible={isModalVisible}
                    onCancel={closeModal}
                    closable={true}
                    maskClosable={false}
                    width={770}
                    footer={[
                        <div className="custom_modal--footer d_flex justify_content_end">
                            <div className="btn_group justify-content-end gap_8">
                                {buttonProcessing ?
                                    <>
                                        <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                            disabled
                                        >
                                            Discard
                                        </button>
                                        <button
                                            className="w_120_d2 btn btn_primary w_fit_content loader"

                                        >
                                            <span>Upload</span>

                                            <img
                                                src={loaderIcon}
                                                alt="USP"
                                                className="loader_icon"
                                            />
                                        </button>
                                    </> :
                                    <>
                                        <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={closeModal}> Discard </button>
                                        <button className="w_120_d2 btn btn_primary w_fit_content" onClick={handleSubmitModal}>Upload</button>
                                    </>
                                }
                            </div>
                        </div>
                    ]}
                >
                    <div className="custom_modal--body">
                        <div className="tab_content--body">
                            <div className="form_content_block--group modal_form_bottom_gap_d2">
                                <label className="form_label">Publisher *</label>
                                <Select
                                    optionLabelProp="label"
                                    className={publisherIsRequiredError ? 'form_select basic no_search error' : 'form_select basic no_search'}
                                    placeholder="-Select-"
                                    options={publisherOptions}
                                    value={publisher}
                                    onChange={onChangePublisher}
                                >
                                </Select>
                                <span className="error_content"> {publisherIsRequiredError && <>  This field is required</>}
                                </span>
                            </div>
                            <div className="form_content_block--group">
                                <label className="form_label">File *</label>
                                <label for='filepublisherDomain01' className='ant_upload_drag'>
                                    <p className="upload_drag_icon">
                                        <img src={uploadIcon} alt='USP' />
                                    </p>
                                    <p className="ant_upload_text"><b className="primary">Click to upload</b> or drag and drop</p>
                                    <p className="ant_upload_hint">
                                        CSV (max. 100 MB)
                                    </p>
                                </label>
                                <input className='form_upload d-none' type="file" id="filepublisherDomain01" name="filepublisherDomain01"
                                    onChange={onChangeFile}
                                />
                                <span className="error_content"> {fileIsRequiredError && <>  This field is required</>}
                                </span>
                            </div>
                            {file?.filename !== "" &&
                                <div class="ant_upload_list--item mb-0 mt-4">
                                    <div class="ant_upload_list--content">
                                        {file.type !== "" ? <>
                                            {file.type === "text/plain" ?
                                                <img src={txtIcon} alt="USP" />
                                                :
                                                <img src={csvIcon} alt="USP" />

                                            }
                                        </> : <></>}

                                        <div class="ant_upload_list--info">
                                            <span class="ant_upload_list--info-name">{file.filename}</span>
                                            {/* <span class="ant_upload_list--info-size">{file.size !== "" ? <>{file.size?.toFixed(2)}  MB</> : <></>}</span> */}
                                            <span class="ant_upload_list--info-size">{file.size !== "" ?
                                                file.size < 1 ?
                                                    (file.size * 1024) < 1 ?
                                                        <>{(file.size * 1024 * 1024)} Bytes </> :
                                                        <>{(file.size * 1024)?.toFixed(2)} KB </> :
                                                    <>{file.size?.toFixed(2)}  MB</> :
                                                <></>}</span>
                                        </div>
                                    </div>
                                    <button type="link" class="ant_upload_list--delete download_icon_d2"
                                        onClick={() => {
                                            setFile({
                                                data: "",
                                                filename: "",
                                                ext: "",
                                                size: ""
                                            })

                                            const fileInput00 = document.getElementById("filepublisherDomain01");
                                            fileInput00.value = "";

                                        }}
                                    >
                                        <img src={deleteIcon} alt="USP" />
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
                </Modal>
            </div>

        </>
    );
};

export default PublisherDomainListing;
